import React, { useState, useEffect } from "react";
import CgDropdown from "../../../common/CgDropdown";
import "./review.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPracticeReviews,
  fetchProviderslistitem,
  updatePracticeReviews,
  updateReviewList,
  handleReviewResponseFormSubmit,
} from "../../../store/Practice/Reviews/ReviewsAction";
import CgFormCreator from "../../../common/CgFormCreator";
import PopupModal from "../../../common/PopupModal";
import ResponsivePagination from "react-responsive-pagination";
import { convertToPercentage } from "../../../utils/commonUtilities";
import { useLocation } from "react-router-dom";
import flagGray from "../../../assets/images/flagGray.svg";
import shieldIcon from "../../../assets/images/shieldIcon.svg";
import brighterReviewLogo from "../../../assets/images/brighterReview.svg";
import { PracticeResponse } from "./PracticeResponse";

const flagStatusMap = {
  UNDER_REVIEW: "Pending",
  REVIEWED: "Closed",
  COMMENT_REMOVED: "Closed",
};

const responseStatusMap = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Not Published - Does not meet editorial guidelines",
};

const formatFlagStatus = (status) => {
  let formattedStatus = flagStatusMap[status];
  return !formattedStatus ? status : formattedStatus;
};

const formatResponseStatus = (status) => {
  let formattedStatus = responseStatusMap[status];
  return !formattedStatus ? status : formattedStatus;
};

const ProviderResponse = ({ item, renderEditResponseCTA }) => {
  const {
    caseNumber,
    providerCommentTimestamp,
    flagStatus,
    providerComment,
    responseStatus,
  } = item;

  if (flagStatus !== "REVIEWED") {
    return null;
  }

  if (
    responseStatus !== "PENDING" &&
    responseStatus !== "APPROVED" &&
    responseStatus !== "REJECTED"
  ) {
    return null;
  }

  return (
    <div className="responded-box">
      <h4>
        Reviewer from the practice responded{" "}
        <span>on {providerCommentTimestamp}</span>
      </h4>
      <div className="comment">
        <p>“{providerComment}”</p>
        {responseStatus !== "APPROVED" ? (
          <div className="case-details-block">
            <ul className="case-details">
              <li>Case Number: {caseNumber}</li>|
              <li>Status: {formatResponseStatus(responseStatus)}</li>
            </ul>
            {responseStatus === "PENDING" || responseStatus === "REJECTED"
              ? renderEditResponseCTA()
              : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const Reviews = () => {
  const [practiceResponseModal, setPracticeResponseModal] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openCenterPopup, setOpenCenterPopup] = useState(false);
  const [providersvalues, setProvidersvalues] = useState([]);
  const [reviewsValues, setReviewsValues] = useState();
  const [reviewListVal, setReviewListVal] = useState([]);
  const [reviewItem, setReviewItem] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState();
  const [recommendRateCon, setRecommendRateCon] = useState();
  const [showError, setShowError] = useState(false);
  const [testAreaInput, setTextAreaInput] = useState("");
  const [nameInput, setNameInput] = useState("");
  const [enableSaveBtn, setEnableSaveBtn] = useState(false);
  const [providerId, setSelectedProviderId] = useState("");
  const [startIndex, setStartIndex] = useState(1);
  const [endIndex, setEndIndex] = useState(10);
  const [surveyFlag, setSurveyFlag] = useState();

  const dispatch = useDispatch();
  const { reviewsData, isReviewsLoading, reviewListerrMsg } = useSelector(
    (state) => state.practiceReviewList,
  );
  const { providersData, providersListerrMsg } = useSelector(
    (state) => state.providersListItem,
  );
  const { updatereviewListData } = useSelector(
    (state) => state.updateReviewLists,
  );
  const page = 1;

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  const providerAPIFetch = async () => {
    const getData = await dispatch(fetchProviderslistitem(practiceId));
    if (getData?.payload?.success === false) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  };

  useEffect(() => {
    providerAPIFetch();
    ReviewAPIFetch(practiceId);
  }, []);

  useEffect(() => {
    if (providersData["providers"]) {
      const practiceDetail = {
        value: providersData?.practiceDisplayName,
        practiceDisplayId: providersData?.practiceDisplayId,
      };
      const providerNames = providersData["providers"]?.map((provider) => {
        return {
          value: provider.providerDisplayName,
          practiceDisplayId: provider.providerDisplayId,
        };
      });
      providerNames.unshift(practiceDetail);
      setProvidersvalues(providerNames);
    }
  }, [providersData]);

  const ReviewAPIFetch = async (practiceDisplayId) => {
    const getdata = await dispatch(fetchPracticeReviews(practiceDisplayId));
    if (getdata?.payload?.success == false) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
    }
  };

  useEffect(() => {
    if (reviewsData.length > 0) {
      setSurveyFlag(true);
      setReviewsValues(reviewsData[0]);
      settotalPages(Math.ceil(reviewsData[0]?.reviews?.length / 10));
      setRecommendRateCon(convertToPercentage(reviewsData[0]?.recommendRate));
      const newStartIndex = (page - 1) * 10;
      const newEndIndex = newStartIndex + 10;
      setStartIndex(newStartIndex);
      setEndIndex(newEndIndex);
      const updatedReviews = reviewsData[0]?.reviews?.slice(
        newStartIndex,
        newEndIndex,
      );
      setReviewListVal(updatedReviews);
      setCurrentPage(page);
    } else {
      setReviewsValues("");
    }
  }, [reviewsData]);

  useEffect(() => {
    if (updatereviewListData.length > 0) {
      setSurveyFlag(false);
      setReviewsValues(updatereviewListData[0]);
      settotalPages(Math.ceil(updatereviewListData[0]?.reviews?.length / 10));
      setRecommendRateCon(
        convertToPercentage(updatereviewListData[0]?.recommendRate),
      );
      const newStartIndex = (page - 1) * 10;
      const newEndIndex = newStartIndex + 10;
      setStartIndex(newStartIndex);
      setEndIndex(newEndIndex);
      const updatedReviews = updatereviewListData[0]?.reviews?.slice(
        newStartIndex,
        newEndIndex,
      );
      setReviewListVal(updatedReviews);
      setCurrentPage(page);
    } else {
      setReviewsValues("");
    }
  }, [updatereviewListData]);

  const handlePageChange = (page) => {
    const newStartIndex = (page - 1) * 10;
    const newEndIndex = newStartIndex + 10;
    setStartIndex(newStartIndex);
    setEndIndex(newEndIndex);

    if (surveyFlag) {
      const updatedReviews = reviewsData[0]?.reviews?.slice(
        newStartIndex,
        newEndIndex,
      );
      setReviewListVal(updatedReviews);
    } else {
      const updatedReviews = updatereviewListData[0]?.reviews?.slice(
        newStartIndex,
        newEndIndex,
      );
      setReviewListVal(updatedReviews);
    }
    setCurrentPage(page);
  };

  const reviewSchema = [
    {
      component: "textarea",
      label: "Please tell us why you are flagging this review:",
      type: "textarea",
      name: "desc",
      needBorder: true,
      required: false,
      onKeyChangeCallback: (name) => {
        setTextAreaInput(name);
      },
    },
    {
      component: "input",
      label: "Your First Name (Required)",
      type: "text",
      name: "name",
      required: true,
      placeholder: " ",
      valueChangeCallback: () => {},
      onKeyChangeCallback: (name, value) => {
        setNameInput(value);
      },
    },
  ];

  useEffect(() => {
    if (testAreaInput && nameInput) {
      setEnableSaveBtn(true);
    } else {
      setEnableSaveBtn(false);
    }
  }, [testAreaInput, nameInput]);

  const RenderReviewListContent = () => {
    if (isReviewsLoading) return null;
    return (
      <>
        {reviewListVal &&
          reviewListVal?.map((item) => {
            return (
              <div key={item.surveyDisplayId}>
                <div className="review-list-content">
                  <div className="review-list-content-left">
                    <h4>Review Date:</h4>
                    <p className="date">{item.date}</p>
                    <h5>Review For:</h5>
                    <span className="review-name">{item.reviewFor}</span>
                    <div>
                      <h5>Review Location:</h5>
                      <address>
                        {item.practiceCityState}
                        <br />
                        {item.practiceStreet1}
                      </address>
                    </div>
                  </div>
                  <div className="review-list-content-right">
                    <div className="first-content">
                      <p>
                        {item.isRecommended == "true" && (
                          <i className="bi bi-hand-thumbs-up"></i>
                        )}
                        {item.isRecommended == "false" && (
                          <i className="bi bi-hand-thumbs-down"></i>
                        )}
                        <span className="isrecommend"> Recommended - </span>
                        <span>Verified Patient</span>
                      </p>
                      {item?.review && item.caseNumber == undefined && (
                        <a
                          id={item.surveyDisplayId}
                          onClick={() => {
                            setOpenPopup(!openPopup);
                            setReviewItem(item);
                          }}
                        >
                          <img src={flagGray} alt="flag" /> Flag this review
                        </a>
                      )}
                    </div>
                    <div className="comment">
                      {item.review !== "" && (
                        <>
                          <p>{item.review}</p>
                          {item.caseNumber && (
                            <div className="case-details-block">
                              <ul className="case-details">
                                <li>Case Number: {item.caseNumber}</li>|
                                <li>
                                  Status: {formatFlagStatus(item.flagStatus)}
                                </li>
                              </ul>
                              {item.flagStatus === "REVIEWED" &&
                              !item.providerComment ? (
                                <button
                                  className="practice-review-respond btn btn-outline-secondary"
                                  onClick={() => {
                                    setPracticeResponseModal(item);
                                  }}
                                >
                                  RESPOND
                                </button>
                              ) : null}
                            </div>
                          )}
                        </>
                      )}
                      {item.review == undefined && (
                        <p className="no-comments-block">
                          <i>No comment provided</i>
                        </p>
                      )}
                    </div>

                    <ProviderResponse
                      item={item}
                      renderEditResponseCTA={() => {
                        return (
                          <button
                            className="practice-review-respond btn btn-outline-secondary"
                            onClick={() => {
                              setPracticeResponseModal(item);
                            }}
                          >
                            Edit
                          </button>
                        );
                      }}
                    />
                  </div>
                </div>
                {practiceResponseModal?.surveyDisplayId ===
                  item.surveyDisplayId && (
                  <PopupModal
                    isOpen={true}
                    onClose={() => {
                      setPracticeResponseModal(null);
                    }}
                    popupHeading="RESPONSE POLICY"
                    customRender={() => {
                      return (
                        <PracticeResponse
                          responseName={
                            practiceResponseModal.providerResponseName
                          }
                          responseComment={
                            practiceResponseModal.providerComment
                          }
                          onSubmitCallback={(payload) => {
                            dispatch(
                              handleReviewResponseFormSubmit({
                                practiceId,
                                providerId,
                                caseNumber: item.caseNumber,
                                payload,
                              }),
                            );
                            setPracticeResponseModal(null);
                          }}
                          patientReview={item}
                          onClose={() => {
                            setPracticeResponseModal(null);
                          }}
                        />
                      );
                    }}
                    width="70%"
                    minWidth="965px"
                  />
                )}
              </div>
            );
          })}
      </>
    );
  };

  const RenderSurveyReviewError = () => {
    if (!showError) return null;
    return (
      <div className="overlay-alert alert alert-danger" role="alert">
        {reviewListerrMsg || providersListerrMsg}
      </div>
    );
  };

  const RenderVerifyViewBlock = () => {
    return (
      <>
        <div className="verify-review-block">
          <div className="select-review">
            <h2>
              Verified Patient Reviews{" "}
              <a
                onClick={() => {
                  setOpenCenterPopup(!openCenterPopup);
                }}
              >
                <i className="bi bi-question-circle"></i> What is this?
              </a>
            </h2>
            <div className="review-block">
              <label>See reviews for:</label>
              {providersData?.length !== 0 ? (
                <CgDropdown
                  dropdownOptions={providersvalues}
                  defaultValue={providersvalues[0]?.value}
                  onSelectCallBack={(name, value, selectedItem) => {
                    const providerId = selectedItem?.practiceDisplayId;
                    dispatch(fetchProviderslistitem(practiceId));
                    if (practiceId === providerId) {
                      ReviewAPIFetch(practiceId);
                    } else {
                      setSelectedProviderId(providerId);
                      dispatch(
                        updateReviewList({
                          practiceId: practiceId,
                          providerId: providerId,
                        }),
                      );
                    }
                    
                  }}
                />
              ) : null}
            </div>
          </div>
          <div className="recommend-review">
            <div className="rec-rate inline">
              <p>Recommendation Rate</p>
              <p className="rec-percentage">
                {reviewsValues?.recommendRate ? recommendRateCon + "%" : "N/A"}
              </p>
              {reviewsValues && <p>From Verified Patients</p>}
            </div>
            <div className="rec-sum inline">
              <p>Recommendation Summary</p>
              <ul>
                <li>
                  <i className="bi bi-hand-thumbs-up"></i> Recommended (
                  {reviewsValues?.totalRecommendCount
                    ? reviewsValues?.totalRecommendCount
                    : 0}
                  )
                </li>
                <li>
                  <i className="bi bi-hand-thumbs-down"></i> Not Recommended (
                  {reviewsValues?.totalNotRecommendCount
                    ? reviewsValues?.totalNotRecommendCount
                    : 0}
                  )
                </li>
              </ul>
            </div>
          </div>
        </div>

        {reviewsValues?.totalReviews > 0 && (
          <div className="review-list">
            <div className="count-line">
              <h4 className="pull-left review-total-display">
                You have {reviewsValues?.totalReviews} reviews from Verified
                Patients
              </h4>

              <div className="pull-right">
                <h4 className="reviews-page-count">
                  Displaying {startIndex + 1} - {endIndex} of{" "}
                  {reviewsValues?.totalReviews}
                </h4>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const RenderCenterPopupContent = () => {
    if (isReviewsLoading) return null;
    return (
      <div className="review-Center-popup">
        <div className="review-Center-content">
          <h2>
            <img src={shieldIcon} alt="" />
            Real reviews from real patients
          </h2>
          <p>
            Brighter works with our insurance carrier partners to survey
            patients that have a dental claim from your office or an appointment
            booked using Brighter Schedule. This means that every review is 100%
            verified from a real patient.
          </p>
          <p>
            Brighter monitors all patient feedback and removes any reviews
            containing inappropriate language or content from your profile. If
            you believe a comment is inaccurate or offensive, you can flag it
            for review by Brighter.
          </p>
          <p>
            If you have any questions or concerns regarding your reviews, please
            contact the Brighter Provider team by calling 1-888-535-0873 or
            using the Contact Us page.
          </p>
        </div>
      </div>
    );
  };

  const RenderFormCreatorForReviews = () => {
    if (isReviewsLoading) return null;
    return (
      <div className="review-CG-Form">
        <div className="review-first-content">
          <p>
            Brighter&apos;s goal is to highlight great dentists by displaying
            reviews from real patients which fairly and accurately represent
            their experience. If you believe a review to be inaccurate or
            offensive, you may flag it for internal review by Brighter.
          </p>
          <p>
            Please provide a brief explanation of why you are flagging this
            review.
          </p>
          <h4>Things to keep in mind:</h4>
          <ul>
            <li>
              Brighter Reviews are from real patients, verified by claims data
              from our carrier partners. For privacy reasons, Brighter does not
              share identifying information about the patient.
            </li>
            <li>
              We may contact you to obtain additional information regarding your
              request.
            </li>
            <li>
              Your request is confidential and will not be displayed publicly.
            </li>
          </ul>
        </div>
        <div className="review-policy-aside">
          <div className="item-content">
            <p className="pull-left">
              {reviewItem?.isRecommended == "true" && (
                <i className="bi bi-hand-thumbs-up"></i>
              )}
              {reviewItem?.isRecommended == "false" && (
                <i className="bi bi-hand-thumbs-down"></i>
              )}
              <span className="isrecommend"> Recommended - </span>
              <span>Verified Patient</span>
            </p>
            <p className="pull-right review-date">
              Reviewed on: <span>{reviewItem.date}</span>
            </p>
          </div>
          <div className="comment">
            {reviewItem?.review !== "" && <p>{reviewItem?.review}</p>}
            {reviewItem?.review == undefined && (
              <p>
                <i>No comment provided</i>
              </p>
            )}
          </div>
          <div className="review-loc">
            <h5 className="inline">Practice Location:</h5>
            <address>
              {reviewItem?.practiceCityState}
              {reviewItem?.practiceStreet1}
            </address>
          </div>
        </div>
        <CgFormCreator
          formClassName="review-practice-form"
          primaryButton="Submit"
          onSubmitCallback={(val) => {
            const payload = {
              surveyDisplayId: reviewItem.surveyDisplayId,
              flagReviewComment: val.desc,
              responseName: val.name,
              userDisplayId: practiceId,
            };
            dispatch(
              updatePracticeReviews({ practiceId: practiceId, data: payload }),
            ).then(() => {
              if (providerId) {
                dispatch(updateReviewList({ practiceId, providerId }));
              } else {
                dispatch(fetchPracticeReviews(practiceId));
              }
            });
            setOpenPopup(!openPopup);
          }}
          schema={reviewSchema}
          onCancel={() => {
            setOpenPopup(false);
            setEnableSaveBtn(false);
          }}
          enablePrimaryBtn={enableSaveBtn}
        />
      </div>
    );
  };

  const RenderCenterPopupModal = () => {
    return (
      <PopupModal
        isOpen={openCenterPopup}
        onClose={() => {
          setOpenCenterPopup(!openCenterPopup);
        }}
        popupHeading=""
        customRender={RenderCenterPopupContent}
        popupType="center"
        width="745px"
      />
    );
  };

  const RenderReviewPopupModal = () => {
    return (
      <PopupModal
        isOpen={openPopup}
        onClose={() => {
          setOpenPopup(!openPopup);
        }}
        popupHeading="REVIEW POLICY"
        customRender={RenderFormCreatorForReviews}
        width="70%"
      />
    );
  };
  return (
    <div className="brighter-reviews">
      <div className="header-logo">
        <img src={brighterReviewLogo} alt="" />
      </div>
      <div className="full-width-container display-flex">
        <div className="col-md-12">
          {RenderVerifyViewBlock()}
          {RenderReviewListContent()}
          {RenderSurveyReviewError()}
          {reviewsValues && (
            <div className="paginate-block">
              <ResponsivePagination
                total={totalPages}
                current={currentPage}
                onPageChange={(page) => handlePageChange(page)}
                maxWidth={400}
                previousLabel="PREV"
                nextLabel="NEXT"
              />
            </div>
          )}
          {openPopup && RenderReviewPopupModal()}
          {openCenterPopup && RenderCenterPopupModal()}
        </div>
      </div>
    </div>
  );
};
export default Reviews;
